import React from 'react';
import styled from 'styled-components';
import { Label } from '../..';
import IDHelpers from '../../../../core/helpers/IDHelper';
import SingleDayMonth from './SingleDayMonth';

const SingleEmptyDayMonth = styled.div`
  display: inline-flex;
  width: 100%;
  max-width: 40px;
  text-align: center;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  min-width: 40px;
  @media (max-width: 768px) {
    min-width: 14.285714%;
    max-width: 14.285714%;
  }
`;

function DaysMonth(props: any) {
  const { days, onSelectDate, selectedDate } = props;
  const numberday = days[0]?.label?.getDay() || 0;
  const firstDay = 7 - numberday;
  let counter = 7 - firstDay;
  const empty = [];
  if (counter !== 0) {
    counter -= 1;
  } else {
    counter = 6;
  }
  for (let index = 0; index < counter; index += 1) {
    empty.push(
      <SingleEmptyDayMonth key={IDHelpers.generateID()}>
        <Label size={14} text="&nbsp;" />
      </SingleEmptyDayMonth>
    );
  }
  return (
    <>
      {empty}
      {days &&
        days.map((day: any) => (
          <SingleDayMonth
            key={IDHelpers.generateID()}
            isToday={day.isToday}
            isInsideWeek={day.isInsideWeek}
            isFirstDayWeek={day.isFirstDayWeek}
            isLastDayWeek={day.isLastDayWeek}
            value={day.label.getDate()}
            dayDate={day.label}
            onSelectDate={onSelectDate}
            isSelectedDay={day.label.toString() === selectedDate.toString()}
            isBeforeToday={day.isBeforeToday}
          />
        ))}
    </>
  );
}

export default DaysMonth;
